import React, { useState } from 'react';

import PageHeader from '../../../components/PageHeader/PageHeader';
import BatchTable from '../../../components/BatchTable/BatchTable';
import { Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomTabPanel from '../../../components/Tab/CustomTabPanel';
import { permissionOptions } from '../../../utils/Enums';
import { useParams } from 'react-router-dom';

export default function Batches() {
  
  const { t } = useTranslation();
  const { locationId } = useParams();
  const [tabValue, setTabValue] = useState(0);

  const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const hasPermission = (permissionId) => userPermissions.includes(permissionId);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChangeTab}>
          {hasPermission(permissionOptions.find(p => p.label === 'VIEW_PREPARATIONS').id) && (
            <Tab label={t('production_lot')} />
          )}
        </Tabs>
      </Box>

      <CustomTabPanel value={tabValue} index={0}>
        <>
          <PageHeader title={t('production_lot')} subtitle={t('manage_production_lot')} />
          <BatchTable locationId={locationId} />
        </>
      </CustomTabPanel>
    </div>
  );
}
